module.exports = __webpack_public_path__ + "pinned.svg?0fd7839460ce051fd4b00fcfe2c5945e";